<template>

  <Animate ref="animate" />

  <!--数据展示-->
  <el-table :data="tableData"
            stripe
            style="width: 100%"
            border
            highlight-current-row
            :header-cell-style="{'text-align':'center'}">
    <el-table-column type="index" :label="$t('messages.序号')" min-width="6" align='center' class="index"/>
    <el-table-column prop="patentName" :label="$t('messages.名字')" min-width="27" align='center'/>
    <el-table-column prop="year" :label="$t('messages.年份')" sortable min-width="11" align='center'/>
    <el-table-column prop="patentOwner" :label="$t('messages.发明人')" min-width="28" align='center' />
    <el-table-column prop="patentNumber" :label="$t('messages.专利号')" min-width="15" align='center'/>
    <el-table-column prop="patentCountry" :label="$t('messages.国家')" min-width="6" align='center'/>
  </el-table>

  <pagination ref="paging" @pagingChange="pagingChange" :total="count"></pagination>

</template>

<script>
  import {ref, reactive, onMounted, getCurrentInstance} from 'vue';
  import { queryPatent, totalPatent } from '@/network/patent'
  import Pagination from "@/components/common/Pagination";
  import Animate from "@/components/common/Animate";

  import {ElMessage, ElMessageBox} from 'element-plus/lib/components'

  export default {
    name: "Patents",
    components:{
      Pagination,
      Animate,
    },
    setup(){

      //记录总专利数
      let instance = reactive({})
      instance = getCurrentInstance();
      let mount = 0;
          totalPatent().then(res => {
        if (res.state === 200)
          mount = res.data;
      })
      // pagination配置
      let tableData = reactive([])
      //先调用一下
      queryPatent(0, 20).then(res => {
        if (res.state === 200){
          res.data.forEach(item => tableData.push(item));
        } else if (result.state === '50000'){
          router.push('/regLogin');
          ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
        }
      })
      let count = ref(0);
      onMounted(() => {
        totalPatent().then(res => {
          if (res.state === 200){
            count.value = res.data;                                 //用props传参不好用,不知道为啥
            instance.proxy.$refs.paging.pagination.total = res.data;  //这个方案好用
          }
        })

        let timer = setTimeout(function () {
          instance.proxy.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)
      })




      function pagingChange(pageSize, currentPage) {
        tableData.length = 0;
        let length = 0;
        if ((currentPage - 1) * pageSize + pageSize > mount)
          length = mount - (currentPage - 1) * pageSize;
        else length = pageSize;
        queryPatent((currentPage - 1) * pageSize, length).then(res => {
          if (res.state === 200){
            res.data.forEach(item => tableData.push(item));
          } else if (result.state === '50000'){
            router.push('/regLogin');
            ElMessage.error(t('regLogin.您的登录信息已过期, 请重新登录'));
          }
        })
      }


      return{ tableData, count,
        pagingChange
      }
    }
  }
</script>

<style scoped lang="less">

  .el-table {
    margin-top: 50px;

  }

  .el-pagination{
    display: flex;
    justify-content: center;
    padding: 40px 20px 100px 0;
  }

</style>